import { createApi } from '@reduxjs/toolkit/query/react';
import { FetchBaseQueryError, fakeBaseQuery } from '@reduxjs/toolkit/dist/query/react';
import { ProfileInterface } from '../../services/exports/Interfaces';
import ProfileManager from '../../services/api/ProfileManager';
import type { QueryReturnValue } from '@reduxjs/toolkit/dist/query/baseQueryTypes';

export const profileApiSlice = createApi({
  baseQuery: fakeBaseQuery(),
  reducerPath: 'profileApiSlice',
  endpoints: (build) => ({
    updateProfile: build.mutation<
      QueryReturnValue<ProfileInterface, FetchBaseQueryError>,
      { companyId: number; data: ProfileInterface }
    >({
      queryFn: ({ companyId, data }) =>
        ProfileManager.putProfile(companyId, data).then((res) => {
          if (res.success) {
            return { data: res.response.data, status: res.status };
          }

          return {
            error: {
              data: res.response,
              status: res.status,
            },
          };
        }),
    }),
  }),
});

export const { useUpdateProfileMutation } = profileApiSlice;
